import { useState } from 'react';

import type User from '@/data/user/model';
import type { AvatarSize } from '@/data/user/model';

import classnames from 'classnames';

import '@/shared/ui/assets/styles/Avatar.scss';

type Props = {
  circle?: boolean;
  className?: string;
  delay?: boolean;
  size?: AvatarSize;
  src?: string;
  user?: User;
};

function Avatar({ circle, className, delay = false, size = 'small', src, user }: Props) {
  const [error, setError] = useState(false);
  const [delayDone, setDelayDone] = useState(false);

  function onError() {
    setError(true);
  }

  function onLoad() {
    if (delay) {
      setDelayDone(true);
    }
  }

  const placeholder = (delay && !delayDone) || !(user || src);

  return (
    <div className={classnames('user-avatar', className, { 'use-placeholder': error || placeholder })}>
      <div className="user-avatar-placeholder" />
      {!placeholder && (
        <img
          alt="avatar"
          className={classnames('d-flex img-fluid', { 'rounded-circle': circle })}
          onError={onError}
          onLoad={onLoad}
          src={src || user?.getAvatar(size)}
        />
      )}
    </div>
  );
}

export default Avatar;
